/**
 * @generated SignedSource<<63776cc336b5ddac4e461a4fec17d0fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetPreferredRoomsMutationInput = {
  clientMutationId?: string | null;
  orgRelayId?: string | null;
  preferredRoomIds: ReadonlyArray<string>;
};
export type SetPreferredRoomsMutation$variables = {
  input: SetPreferredRoomsMutationInput;
};
export type SetPreferredRoomsMutation$data = {
  readonly setPreferredRooms: {
    readonly suggestedRoomPreferences: {
      readonly id: string;
      readonly suggestedRooms: ReadonlyArray<{
        readonly isPreferred: boolean;
        readonly isSuggested: boolean;
        readonly room: {
          readonly roomId: string;
          readonly name: string;
          readonly orgId: string;
          readonly estimatedCapacity: number | null;
          readonly reportedCapacity: number | null;
        };
      }>;
    };
  } | null;
};
export type SetPreferredRoomsMutation = {
  variables: SetPreferredRoomsMutation$variables;
  response: SetPreferredRoomsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPreferred",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSuggested",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roomId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedCapacity",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reportedCapacity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetPreferredRoomsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetPreferredRoomsMutationPayload",
        "kind": "LinkedField",
        "name": "setPreferredRooms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SuggestedRoomPreferences",
            "kind": "LinkedField",
            "name": "suggestedRoomPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedRoomPreference",
                "kind": "LinkedField",
                "name": "suggestedRooms",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Room",
                    "kind": "LinkedField",
                    "name": "room",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetPreferredRoomsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetPreferredRoomsMutationPayload",
        "kind": "LinkedField",
        "name": "setPreferredRooms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SuggestedRoomPreferences",
            "kind": "LinkedField",
            "name": "suggestedRoomPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedRoomPreference",
                "kind": "LinkedField",
                "name": "suggestedRooms",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Room",
                    "kind": "LinkedField",
                    "name": "room",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52d0766ae202f97e151ffa6819c6ff32",
    "id": null,
    "metadata": {},
    "name": "SetPreferredRoomsMutation",
    "operationKind": "mutation",
    "text": "mutation SetPreferredRoomsMutation(\n  $input: SetPreferredRoomsMutationInput!\n) {\n  setPreferredRooms(input: $input) {\n    suggestedRoomPreferences {\n      id\n      suggestedRooms {\n        isPreferred\n        isSuggested\n        room {\n          roomId\n          name\n          orgId\n          estimatedCapacity\n          reportedCapacity\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30702dbd9b01be1725103f60b3e5ede9";

export default node;
